import { Observable } from 'rxjs/Rx'
import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import * as authenticationDuck from 'store/ducks/authentication'
import { combineEpics } from 'redux-observable'
import { ScenarioParams, getScenarioList } from 'store/services/scenarioProposal'
import { GlobalState } from './state'
import { ScenarioProposal } from 'interfaces/scenario'

export type ScenarioProposalsState = {
  scenarioList: ScenarioProposal[]
  isLoading: boolean
}

const INITIAL_STATE: ScenarioProposalsState = {
  scenarioList: [],
  isLoading: false,
}

type ScenarioProposalsReducer<A = undefined> = (state: ScenarioProposalsState, action?: PayloadAction<A>) => void

const proposalsSlice = createSlice({
  name: 'scenarioProposals',
  initialState: INITIAL_STATE,
  reducers: {
    fetchScenarioList: ((state) => {
      state.isLoading = true
    }) as ScenarioProposalsReducer<ScenarioParams>,
    fetchScenarioListSuccess: ((state, action) => {
      state.scenarioList = action.payload
      state.isLoading = false
    }) as ScenarioProposalsReducer<ScenarioProposal[]>,
    fetchScenarioListFailure: ((state) => {
      state.isLoading = false
    }) as ScenarioProposalsReducer,
  },
})

export const { fetchScenarioList, fetchScenarioListSuccess, fetchScenarioListFailure } = proposalsSlice.actions

export const reducer = proposalsSlice.reducer

export const epic = combineEpics(scenarioListRequestEpic)

export function scenarioListRequestEpic(action$) {
  return action$.ofType(fetchScenarioList.type).mergeMap((action) => {
    return (
      Observable.ajax(getScenarioList(action.payload))
        .mergeMap((res) => Observable.of(fetchScenarioListSuccess(res.response['hydra:member'])))
        // @ts-ignore
        .catch((err) => {
          if (typeof err === 'object' && (err.response || {}).code === 401) {
            return Observable.of(authenticationDuck.refreshTokenRequest(action))
          }

          return Observable.of(fetchScenarioListFailure())
        })
    )
  })
}

export const selectScenarioProposals = (state: GlobalState) => state.scenarioProposals
